import { render } from "./PlantTypes.vue?vue&type=template&id=d746bb04"
import script from "./PlantTypes.vue?vue&type=script&lang=js"
export * from "./PlantTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__